<template>
  <div class="trigger" :class="{ disabled }">
    <label class="trigger__checkbox custom-trigger" :class="{ disabled, small }">
      <input :type="type" :disabled="disabled" :checked="isChecked" :value="value" @click="change" />
      <span class="custom-trigger__slider custom-trigger__round"></span>
    </label>

    <div v-if="text" class="trigger__text" @click="change">{{ text }}</div>
  </div>
</template>

<script>
export default {
  name: 'VcvCheckbox',

  props: {
    type: {
      type: String,
      default: 'checkbox' // or 'radio'
    },

    value: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: Boolean,
      default: false
    },

    // Для label текста (кликабельный)
    text: {
      type: String,
      default: ''
    },

    small: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    isChecked() {
      return this.value;
    }
  },

  methods: {
    change() {
      this.$emit('input', !this.value);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/fonts.scss';

.trigger {
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  &.disabled {
    pointer-events: none;
  }

  &__text {
    margin-left: 10px;
    @include mixin-text-main;
    cursor: pointer;
  }

  &__checkbox {
    transition: opacity 0.2s;

    &.disabled {
      opacity: 0.45;
      transition: opacity 0.2s;
    }
  }
}

.custom-trigger {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 20px;
  margin-bottom: 0;
  font-size: 12px !important;

  input {
    display: none;
  }

  input:checked + .custom-trigger__slider,
  input[value='true'] + .custom-trigger__slider {
    background-color: $green;
  }

  input:focus + .custom-trigger__slider {
    box-shadow: 0 0 1px #e8e8e8;
  }

  input:checked + .custom-trigger__slider:before,
  input[value='true'] + .custom-trigger__slider:before {
    content: '';
    transform: translateX(20px);
  }

  &__slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #b4b4b4;
    -webkit-transition: 0.4s;
    transition: 0.4s;

    &:before {
      position: absolute;
      content: '';
      display: flex;
      justify-content: center;
      align-items: center;
      width: 16px;
      height: 16px;
      left: 2px;
      bottom: 2px;
      background-color: #ffffff;
      transition: 0.4s;
    }

    &.custom-trigger__round {
      border-radius: 10px;

      &:before {
        border-radius: 10px;
      }
    }
  }

  &.small {
    height: 12px;
    width: 26px;

    .custom-trigger__slider:before {
      width: 10px;
      height: 10px;
      bottom: auto;
      top: 1px;
    }

    input:checked + .custom-trigger__slider:before,
    input[value='true'] + .custom-trigger__slider:before {
      content: '';
      transform: translateX(12px);
    }
  }
}

.disabled .custom-trigger__slider {
  cursor: default;
}
</style>
